import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "./app";

export enum AlertTypeEnum {
    Error = 1,
    Info,
    Success,
    Warning
}

export enum ModeEnum {
    Add,
    Edit
}

export enum ProgramEnum {
    Bike = 1,
    SwimSpring = 2,
    Trail = 1001,
    BikeSwim = 1002,
    BikeSchool = 1005,
    Sport = 1006,
    BikeSport = 1007,
    TrailSwim = 1008,
    Swim = 1009,
    SwimDropIn = 1010
}

export class Region {
    id: number;
    name: string;
    currency: string;

    constructor(data: any) {
        let self = this;

        self.id = data.id;
        self.name = data.name;
        self.currency = data.currency;
    }
}

export class Timer {
    title: string;
    url: string;

    minutes = ko.observable(0);
    seconds = ko.observable(0);

    text: ko.PureComputed<string>;

    constructor(model: any) {
        let self = this;

        const data = JSON.parse(model);

        self.title = data.title;
        self.url = data.url;
        self.minutes(data.minutes);
        self.seconds(data.seconds);

        self.text = ko.pureComputed(() => {
            let m = self.minutes();
            let s = self.seconds();

            let min = m.toString();
            let sec = s.toString();

            if (m < 10 && m >= 0) { min = "0" + min }
            if (s < 10 && s >= 0) { sec = "0" + sec }

            return min + ":" + sec;
        }, self);

        let checkSecond = (sec) => {
            if (sec < 0) { sec = 59 };
            return sec;
        }

        let startTimer = () => {
            let s = checkSecond(self.seconds() - 1);
            let m = self.minutes();

            if (s == 59) { m-- }

            if (m < 0) { App.alertInfo("Timer completed"); return; }

            self.seconds(s);
            self.minutes(m);

            setTimeout(startTimer, 1000);
        }

        startTimer();
    }
}

export class InfoToast {
    style: string;
    title: string
    close: () => void;

    constructor(private root: InfoToasts, public alertType: AlertTypeEnum, public message: string) {
        let self = this;

        self.style = InfoToasts.toastStyle(alertType);
        self.title = InfoToasts.toastTitle(alertType);

        self.close = () => {
            self.root.toasts.remove(self);
        }
    }
}

interface AlertTypeStyle {
    key: AlertTypeEnum;
    value: string;
    title: string;
}

export class InfoToasts {
    static styles: Array<AlertTypeStyle> = [
        { key: AlertTypeEnum.Error, value: 'error', title: 'Oh no, error' },
        { key: AlertTypeEnum.Info, value: 'info', title: 'Note:' },
        { key: AlertTypeEnum.Success, value: 'success', title: 'Great!' },
        { key: AlertTypeEnum.Warning, value: 'warning', title: 'Warning!' }
    ];

    toasts = ko.observableArray<InfoToast>();

    toast: (message: string, style: AlertTypeEnum) => void;

    constructor(model) {
        let self = this;

        const data = JSON.parse(model);

        self.toasts(_(data.messages).map(x => new InfoToast(self, x.style, x.value)));

        self.toast = (message: string, style: AlertTypeEnum) => {
            self.toasts.push(new InfoToast(self, style, message));
            //_(self.toasts()).each(x => console.log(x.message));
        };
    }

    public static toastStyle(key: number) {
        const match = InfoToasts.styles.find(x => x.key.valueOf() === key);
        return match ? match.value : "success";
    }

    public static toastTitle(key: number) {
        const match = InfoToasts.styles.find(x => x.key.valueOf() === key);
        return match ? match.title : "title";
    }
}

export class Toastr {
    public static confirm(msg: string): boolean {
        return window.confirm(msg);
    }
}

